export const MAX_COMBINED_SUMMARY_ROWS = 20;
export const MAX_META_FIELDS_PER_PAGE = 20;
export const MAX_FRUIT_ROWS_PER_PAGE = 24;

function chunkItems<T>(items: T[], size: number): T[][] {
    if (items.length === 0) return [[]];

    return Array.from(
        { length: Math.ceil(items.length / size) },
        (_, index) => items.slice(index * size, (index + 1) * size)
    );
}

export interface PDFCheckFruitTablePagePlan<Field, Row> {
    combineSummaryAndTable: boolean;
    summaryFieldPages: Field[][];
    tableRowPages: Row[][];
}

/**
 * Keep small reports compact, but explicitly paginate larger reports rather
 * than relying on react-pdf to split an overflowing flex layout.
 */
export const createPDFCheckFruitTablePagePlan = <Field, Row>(
    fields: Field[],
    rows: Row[]
): PDFCheckFruitTablePagePlan<Field, Row> => {
    const combineSummaryAndTable = fields.length <= MAX_META_FIELDS_PER_PAGE
        && fields.length + rows.length <= MAX_COMBINED_SUMMARY_ROWS;

    return {
        combineSummaryAndTable,
        summaryFieldPages: chunkItems(fields, MAX_META_FIELDS_PER_PAGE),
        tableRowPages: combineSummaryAndTable
            ? []
            : chunkItems(rows, MAX_FRUIT_ROWS_PER_PAGE),
    };
};
